/**
 * @returns {Object}
 * @description This is a kinda pointless factory that angular has, it will always
 * output the same config object regardless of app type. but ive added it so that
 * the angular code will still function correctly, but we can access the data
 * here in vue also. This is used in angular to construct a factory in vue you
 * can use like this
 *
 * @example
 * const appSpecificOptions = appSpecificOptionsFactory()
 * appSpecificOptions.get(app.type, (options) => {
 *  console.log(options)
 * })
 */
export const appSpecificOptionsFactory = () => {
  return {
    get: (type, cb) => {
      const opts = vouncherOptions.voucher
      return cb(opts)
    },
  }
}

export const appAutoresponseTemplatesFactory = () => {
  // Expose the method to return the correct templates object
  return {
    get: (type, cb) => {
      const opts = autoResponseTemplates[type] || {}
      return cb(opts)
    },
  }
}

/**
 * @returns {Object}
 * @description
 * A factory function that returns an object that can fetchs a default form
 * config object for a given app type
 *
 * @example
 *
 */
export const appFormTemplatesFactory = () => {
  // Expose the method to return the correct form object
  return {
    get: (type, cb) => {
      const form = appFormTemplates[type] || {}
      return typeof cb === 'function' ? cb(form) : form
    },
  }
}

/**
 * @type {Object}
 * @description Contains all of the options for the appSpecificOptionsFactory
 * factory
 */
export const vouncherOptions = {
  voucher: {
    account: '', // Account this voucher is tied to
    custom: '', // Custom voucher code, i.e. a single voucher code.
    depletedMessage: '', // Show when voucher limit reached or when paused.
    format: '@@-@@#-#@@', // Format: @ = letters, # = numbers
    generated: 0, // Array of generated vouchers
    max: {
      enabled: false, // Whether to cap the amount of vouchers
      vouchers: 50000, // Maximum number of vouchers
    },
    paused: false, // Whether to pause the generation of vouchers
    redeemed: 0, // Array of redeemed vouchers
    type: 'generated', // Type: generated/custom
  },
}

/**
 * @type {Object}
 * @description Contains the auto response templates for the appAutoresponseTemplatesFactory
 */
export const autoResponseTemplates = {
  /**
   *	Autoresponse templates for competition app
   */
  competition: {
    email:
      '<p>Dear [[FULL-NAME]],<br /><br />' +
      "Thank you for your competition entry. We'll be in touch.<br /><br />" +
      'All the best,<br /><br /></p>',

    sms:
      'Dear [[FULL-NAME]],\n\n' +
      "Thank you for your competition entry. We'll be in touch.\n\n" +
      'All the best,',
  },

  /**
   *	Autoresponse templates for promo app
   */
  promo: {
    email:
      '<p>Dear [[FULL-NAME]],<br /><br />' +
      "Thank you for your enquiry. We'll be in touch.<br /><br />" +
      'All the best,</p>',

    sms:
      'Dear [[FULL-NAME]],\n\n' +
      "Thank you for your enquiry. We'll be in touch.\n\n" +
      'All the best,',
  },

  /**
   *	Autoresponse templates for voucher app
   */
  voucher: {
    email:
      '<p>Dear [[FULL-NAME]],<br /><br />' +
      'Your voucher code is: [[VOUCHER-CODE]]<br /><br />' +
      'All the best,</p>',

    sms:
      'Dear [[FULL-NAME]],\n\n' +
      'Your voucher code is: [[VOUCHER-CODE]]\n\n' +
      'All the best,',
  },

  /**
   *	Autoresponse templates for promo app
   */
  embed: {
    email:
      '<p>Dear [[FULL-NAME]],<br /><br />' +
      "Thank you for your enquiry. We'll be in touch.<br /><br />" +
      'All the best,</p>',

    sms:
      'Dear [[FULL-NAME]],\n\n' +
      "Thank you for your enquiry. We'll be in touch.\n\n" +
      'All the best,',
  },
}

/**
 * @type {Object}
 * @description Contains all the default form configs for specific types
 * used in the appFormTemplatesFactory
 */
export const appFormTemplates = {
  /**
   *	Promo specific form
   */
  promo: {
    enableConversion: false,
    primaryResponse: 'message',
    submit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Get in touch',
    },
    conversionSubmit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    successMessage: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Thank you!',
        dataType: 'successMessage',
        position: 0,
        fieldId: '6a62cdb6-4fa6-4c68-9e43-9889a4a5ee87',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'HTML/Text',
        name: 'copy',
        icon: 'code',
        type: 'copy',
        fieldType: 'copy',
        value: '<p>We will be in touch shortly.</p>',
        dataType: 'successMessage',
        position: 1,
        fieldId: 'd1e0df5a-005b-43ed-866a-f8a20c911e27',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    successPage: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Thank you!',
        dataType: 'successPage',
        position: 0,
        fieldId: '6a62cdb6-4fa6-4c68-9e43-9889a4a5ee87',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'HTML/Text',
        name: 'copy',
        icon: 'code',
        type: 'copy',
        fieldType: 'copy',
        value: '<p>We will be in touch shortly.</p>',
        dataType: 'successPage',
        position: 1,
        fieldId: 'd1e0df5a-005b-43ed-866a-f8a20c911e27',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    conversion_form: [
      {
        tag: 'Heading',
        name: 'newheading1396883531560',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Tell us more',
        dataType: 'conversion_form',
        position: 0,
        fieldId: '0b694582-4044-4e2e-a1d1-8cbf40d4dbbd',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Message',
        name: 'textarea1396883547126',
        icon: 'comments',
        type: 'textarea',
        fieldType: 'message',
        placeholder: '',
        label: 'Comments',
        preset: true,
        dataType: 'conversion_form',
        position: 1,
        fieldId: 'a53367a1-6cf9-4bb1-e13f-c5aeaedf5f4b',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    fields: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Get in touch',
        dataType: 'fields',
        position: 0,
        fieldId: '7f4cbe6f-e4be-4a3e-8aa2-bda02e24348c',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'First Name',
        name: 'firstname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'First Name',
        label: 'First Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 1,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91c',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'fname',
      },
      {
        tag: 'Last Name',
        name: 'surname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'Last Name',
        label: 'Last Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 2,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91v',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'lname',
      },
      {
        tag: 'Email',
        name: 'email',
        icon: 'envelope',
        type: 'email',
        fieldType: 'email',
        placeholder: 'Email',
        label: 'Email',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 3,
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dc',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'email',
      },
      {
        tag: 'Mobile Number',
        name: 'mobile',
        icon: 'phone',
        type: 'tel',
        fieldType: 'mobile',
        placeholder: 'Mobile Number',
        label: 'Mobile Number',
        dataType: 'fields',
        position: 4,
        preset: true,
        validation: {
          pattern: {
            regex: '/^\\+[0-9]{1,3}\\.[0-9]{4,14}(?: x.+)?$/',
            message: 'Please enter a valid international mobile number',
          },
        },
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dn',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'mobile',
      },
    ],
  },

  /**
   *	Competition specific form
   */
  competition: {
    enableConversion: false,
    submit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    conversionSubmit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    primaryResponse: 'message',
    successMessage: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Thank you for your entry',
        dataType: 'successMessage',
        position: 0,
        fieldId: '0680376c-aed1-4152-9c74-fd6db7532069',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'HTML/Text',
        name: 'copy',
        icon: 'code',
        type: 'copy',
        fieldType: 'copy',
        value: '<p>We will be in touch if you are a lucky winner.</p>',
        dataType: 'successMessage',
        position: 1,
        fieldId: 'abac5e1f-a616-4ed5-a679-a98766d32a27',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    successPage: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Thank you for your entry',
        dataType: 'successPage',
        position: 0,
        fieldId: '0680376c-aed1-4152-9c74-fd6db7532069',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'HTML/Text',
        name: 'copy',
        icon: 'code',
        type: 'copy',
        fieldType: 'copy',
        value: '<p>We will be in touch if you are a lucky winner.</p>',
        dataType: 'successPage',
        position: 1,
        fieldId: 'abac5e1f-a616-4ed5-a679-a98766d32a27',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    conversion_form: [
      {
        tag: 'Heading',
        name: 'newheading1396883531560',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Tell us more',
        dataType: 'conversion_form',
        position: 0,
        fieldId: '0b694582-4044-4e2e-a1d1-8cbf40d4dbbd',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Message',
        name: 'textarea1396883547126',
        icon: 'comments',
        type: 'textarea',
        fieldType: 'message',
        placeholder: '',
        label: 'Comments',
        preset: true,
        dataType: 'conversion_form',
        position: 1,
        fieldId: 'a53367a1-6cf9-4bb1-e13f-c5aeaedf5f4b',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    fields: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Get in touch',
        dataType: 'fields',
        position: 0,
        fieldId: '7f4cbe6f-e4be-4a3e-8aa2-bda02e24348c',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'First Name',
        name: 'firstname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'First Name',
        label: 'First Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 1,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91c',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'fname',
      },
      {
        tag: 'Last Name',
        name: 'surname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'Last Name',
        label: 'Last Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 2,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91v',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'lname',
      },
      {
        tag: 'Email',
        name: 'email',
        icon: 'envelope',
        type: 'email',
        fieldType: 'email',
        placeholder: 'Email',
        label: 'Email',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 3,
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dc',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'email',
      },
      {
        tag: 'Mobile Number',
        name: 'mobile',
        icon: 'phone',
        type: 'tel',
        fieldType: 'mobile',
        placeholder: 'Mobile Number',
        label: 'Mobile Number',
        dataType: 'fields',
        position: 4,
        preset: true,
        validation: {
          pattern: {
            regex: '/^\\+[0-9]{1,3}\\.[0-9]{4,14}(?: x.+)?$/',
            message: 'Please enter a valid international mobile number',
          },
        },
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dn',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'mobile',
      },
      {
        tag: "T&C's",
        name: 'terms',
        icon: 'file-text',
        fieldType: 'terms-and-conditions',
        type: 'terms-and-conditions',
        label: 'Terms & Conditions',
        value: '',
        text: 'I agree to the',
        title: 'Terms & Conditions',
        validation: {
          required: true,
        },
        dataType: 'fields',
        position: 5,
        fieldId: '5b44b076-74da-4e04-dde7-914a4300d2dd',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Privacy Policy',
        name: 'privacy',
        icon: 'file-text',
        fieldType: 'privacy-policy',
        type: 'privacy-policy',
        label: 'Privacy Policy',
        value: '',
        text: 'I have read the',
        title: 'Privacy Policy',
        validation: {
          required: true,
        },
        dataType: 'fields',
        position: 5,
        fieldId: '38aab578-ab45-425a-bd2f-fee6034a92c0',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
  },

  /**
   *	Event app form
   */
  event: {
    enableConversion: false,
    submit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    conversionSubmit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
  },

  /**
   *	Photo competition form
   */
  'photo-comp': {
    enableConversion: false,
    submit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    conversionSubmit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
  },

  /**
   *	Application form for voucher app
   */
  voucher: {
    enableConversion: false,
    primaryResponse: 'email',
    submit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    conversionSubmit: {
      icon: 'icon-ok',
      classes: 'btn-default',
      value: 'Submit',
    },
    successMessage: [
      {
        fieldId: '826988fe-2e6c-4e75-f2cf-893855cf394b',
        position: 0,
        dataType: 'successMessage',
        value: 'Thank you, here is your voucher code: ',
        fieldType: 'newheading',
        headingSize: 2,
        type: 'newheading',
        icon: 'font',
        name: 'newheading',
        tag: 'Heading',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Voucher',
        name: 'voucher',
        icon: 'pricetags',
        type: 'voucher',
        fieldType: 'title',
        dataType: 'successMessage',
        position: 1,
        fieldId: '3f14b5c2-5f67-4dc0-d0ed-962f87946c60',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    successPage: [
      {
        fieldId: '826988fe-2e6c-4e75-f2cf-893855cf394b',
        position: 0,
        dataType: 'successPage',
        value: 'Thank you, here is your voucher code: ',
        fieldType: 'newheading',
        type: 'newheading',
        icon: 'font',
        name: 'newheading',
        headingSize: 2,
        tag: 'Heading',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Voucher',
        name: 'voucher',
        icon: 'pricetags',
        type: 'voucher',
        fieldType: 'title',
        dataType: 'successPage',
        position: 1,
        fieldId: '3f14b5c2-5f67-4dc0-d0ed-962f87946c60',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    conversion_form: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 1,
        value: 'Tell us more',
        dataType: 'conversion_form',
        position: 0,
        fieldId: '0b694582-4044-4e2e-a1d1-8cbf40d4dbbd',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Message',
        name: 'textarea1396883547126',
        icon: 'comments',
        type: 'textarea',
        fieldType: 'message',
        placeholder: '',
        label: 'Comments',
        preset: true,
        dataType: 'conversion_form',
        position: 1,
        fieldId: 'a53367a1-6cf9-4bb1-e13f-c5aeaedf5f4b',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
    fields: [
      {
        tag: 'Heading',
        name: 'newheading',
        icon: 'font',
        type: 'newheading',
        fieldType: 'newheading',
        headingSize: 2,
        value: 'Get in touch',
        dataType: 'fields',
        position: 0,
        fieldId: '7f4cbe6f-e4be-4a3e-8aa2-bda02e24348c',
        validation: {},
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'First Name',
        name: 'firstname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'First Name',
        label: 'First Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 1,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91c',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'fname',
      },
      {
        tag: 'Last Name',
        name: 'surname',
        icon: 'user',
        type: 'text',
        fieldType: 'name',
        placeholder: 'Last Name',
        label: 'Last Name',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 2,
        fieldId: 'f07fd5f0-82e5-4b7a-86f7-472bfd11c91v',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'lname',
      },
      {
        tag: 'Email',
        name: 'email',
        icon: 'envelope',
        type: 'email',
        fieldType: 'email',
        placeholder: 'Email',
        label: 'Email',
        validation: {
          required: true,
        },
        preset: true,
        dataType: 'fields',
        position: 3,
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dc',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'email',
      },
      {
        tag: 'Mobile Number',
        name: 'mobile',
        icon: 'phone',
        type: 'tel',
        fieldType: 'mobile',
        placeholder: 'Mobile Number',
        label: 'Mobile Number',
        dataType: 'fields',
        position: 4,
        preset: true,
        validation: {
          pattern: {
            regex: '/^\\+[0-9]{1,3}\\.[0-9]{4,14}(?: x.+)?$/',
            message: 'Please enter a valid international mobile number',
          },
        },
        fieldId: '4d24289f-4107-4a6b-9d9f-526a392ee7dn',
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
        templateVar: 'mobile',
      },
      {
        tag: "T&C's",
        name: 'terms',
        icon: 'file-text',
        fieldType: 'terms-and-conditions',
        type: 'terms-and-conditions',
        label: 'Terms & Conditions',
        value: '',
        text: 'I agree to the',
        title: 'Terms & Conditions',
        validation: {
          required: true,
        },
        dataType: 'fields',
        position: 5,
        fieldId: '5b44b076-74da-4e04-dde7-914a4300d2dd',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
      {
        tag: 'Privacy Policy',
        name: 'privacy',
        icon: 'file-text',
        fieldType: 'privacy-policy',
        type: 'privacy-policy',
        label: 'Privacy Policy',
        value: '',
        text: 'I agree to the',
        title: 'Privacy Policy',
        validation: {
          required: true,
        },
        dataType: 'fields',
        position: 5,
        fieldId: '5b44b076-74da-4e04-dde7-914a4300d2de',
        primaryResponse: false,
        rules: [],
        ruleType: 'all',
        exportLabel: '',
        exportLabelOn: false,
      },
    ],
  },
}
